import type { TripDetailsV2 } from "@b2bportal/air-disruption-api";
import type { TripSlice } from "@b2bportal/air-shopping-api";
import type { Airport } from "@b2bportal/air-shopping-api";
import { useFlightStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { I18nMarkup, useI18nContext } from "@hopper-b2b/i18n";
import type { TripDetails, FareDetails } from "@hopper-b2b/types";
import { MobileFlightDetailsModal } from "@hopper-b2b/ui";
import clsx from "clsx";
import dayjs from "dayjs";
import AirplaneOutlinedWhite from "../../../assets/client/darkMode/airplane-outline-white.svg";
import LocationMarkerWhite from "../../../assets/client/darkMode/location-marker-white.svg";
import defaultStyles from "./FlightDetailsDialog.module.scss";

export const FlightDetailsDialog = ({
  open,
  onClose,
  onClick,
  flightSlice,
  flightDetails,
  isOutbound,
  sliceIndex,
  airports,
}: {
  open: boolean;
  flightSlice?: TripSlice;
  flightDetails: TripDetailsV2;
  isOutbound: boolean;
  onClose: () => void;
  onClick: () => void;
  sliceIndex: number;
  airports?: { [key: string]: Airport };
}) => {
  const COMPONENT_KEY = CoreFlightsComponent.FlightDetailsDialog;
  const styles = useFlightStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const assets = {
    airplane: AirplaneOutlinedWhite,
    locationMarker: LocationMarkerWhite,
  };

  return (
    <>
      {flightSlice == null ? null : (
        <MobileFlightDetailsModal
          departure={false}
          tripDetails={flightDetails as unknown as TripDetails}
          fareDetails={
            flightDetails.fareDetails[sliceIndex] as unknown as FareDetails
          }
          openModal={open}
          onClose={onClose}
          className={clsx(
            "b2b",
            "b2b-secondary",
            "mobile-itinerary-details-modal"
          )}
          title={
            <I18nMarkup
              tKey={
                isOutbound
                  ? "flightShopReview.returnCardHeader"
                  : "flightShopReview.outboundCardHeader"
              }
              replacements={{
                location: isOutbound
                  ? airports[flightSlice?.destinationCode].cityName
                  : airports[flightSlice?.originCode].cityName,
                date: dayjs(flightSlice?.departureTime).format("ddd, MMM D"),
              }}
            />
          }
          buttonText={t("continue")}
          onClick={onClick}
          airports={airports}
          assets={assets}
        />
      )}
    </>
  );
};
